export default __webpack_public_path__ + "static/media/wa.d111e520.svg";